// Read-only Solana wallet discovery — Wallet Standard window events + injected fallbacks.
// The ticket flow never requests a transaction, signature, approval or key.

const registered = [];
let initialized = false;

function notifyWalletsChanged() {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('thomas:wallets-changed'));
}

export function initWalletDiscovery() {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;
  const api = {
    register: (...wallets) => {
      wallets.forEach((w) => {
        if (w && !registered.includes(w)) registered.push(w);
      });
      notifyWalletsChanged();
      return () => {};
    },
  };
  try {
    window.addEventListener('wallet-standard:register-wallet', (event) => {
      try { event.detail(api); } catch {}
    });
    window.dispatchEvent(new CustomEvent('wallet-standard:app-ready', { detail: api }));
    window.setTimeout(notifyWalletsChanged, 250);
  } catch {}
}

export function getSolanaWallets() {
  const list = [];
  registered.forEach((w) => {
    const solChain = (w.chains || []).some((c) => String(c).startsWith('solana:'));
    if (solChain && w.features && w.features['standard:connect']) {
      list.push({ name: w.name, icon: w.icon, kind: 'standard', ref: w });
    }
  });
  // injected fallbacks (deduped by name)
  const has = (name) => list.some((w) => w.name.toLowerCase().includes(name));
  if (typeof window !== 'undefined') {
    if (window.solana?.isPhantom && !has('phantom')) {
      list.push({ name: 'Phantom', icon: null, kind: 'injected', ref: window.solana });
    }
    if (window.solflare?.isSolflare && !has('solflare')) {
      list.push({ name: 'Solflare', icon: null, kind: 'injected', ref: window.solflare });
    }
    if (window.backpack?.isBackpack && !has('backpack')) {
      list.push({ name: 'Backpack', icon: null, kind: 'injected', ref: window.backpack });
    }
  }
  return list;
}

export async function connectWallet(entry) {
  if (entry.kind === 'standard') {
    const res = await entry.ref.features['standard:connect'].connect();
    const account =
      (res.accounts || []).find((a) => (a.chains || []).some((c) => String(c).startsWith('solana:'))) ||
      (res.accounts || [])[0];
    if (!account) throw new Error('No account returned');
    return account.address;
  }
  const res = await entry.ref.connect();
  const pk = res?.publicKey || entry.ref.publicKey;
  if (!pk) throw new Error('No public key returned');
  return pk.toString();
}

export async function disconnectWallet(entry) {
  try {
    if (entry?.kind === 'standard' && entry.ref.features['standard:disconnect']) {
      await entry.ref.features['standard:disconnect'].disconnect();
    } else if (entry?.kind === 'injected' && entry.ref.disconnect) {
      await entry.ref.disconnect();
    }
  } catch {}
}

export async function fetchSolanaTokenBalance(owner, mint) {
  if (!owner || !mint) return null;
  const rpc = (process.env.REACT_APP_SOLANA_RPC_URL || 'https://api.mainnet-beta.solana.com').trim();
  const response = await fetch(rpc, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      jsonrpc: '2.0',
      id: 'thomas-ticket-holder-stamp',
      method: 'getTokenAccountsByOwner',
      params: [owner, { mint }, { encoding: 'jsonParsed' }],
    }),
  });
  if (!response.ok) return null;
  const payload = await response.json();
  if (!Array.isArray(payload?.result?.value)) return null;
  return payload.result.value.reduce((sum, account) => {
    const amount = account?.account?.data?.parsed?.info?.tokenAmount?.uiAmount;
    return sum + (typeof amount === 'number' ? amount : 0);
  }, 0);
}
